import type {GetTokens, WorkHit} from './types';
import workQuery from './data/workQuery.json';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {normalizeQuery} from './functions';
import {httpElasticV2} from './http/search/httpElastic';
import {mapWorkHits} from './mappers/mapWorkHits';
import type {SearchSchemas} from './search.dto.generated';
import type {SearchResult, SearchResultDto} from './searchTypes';

export const searchWork = (
  query: string,
  page: number,
  size: number,
  getTokens: GetTokens,
  signal?: AbortSignal,
  includeHachetteWorks?: boolean,
): Promise<SearchResult<WorkHit>> => {
  const normalizedQuery = normalizeQuery(query);
  /**
   * Placed the JSON in a file to easier debug it in elastic cloud console.
   */
  const elasticQuery = JSON.stringify(workQuery)
    .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
    .replaceAll(
      '"${EXCLUDED_PRODUCTOWNERS_PLACEHOLDER}"',
      includeHachetteWorks
        ? '["4252", "4296", "4476"]'
        : '["4252", "4296", "4476", "4253"]', // 4253 is Hachette
    );

  return exceptionToPromiseReject(() =>
    httpElasticV2<SearchResultDto<SearchSchemas.WorkDocument>>(
      getTokens,
      'ebs-work-alias',
      JSON.parse(elasticQuery),
      page,
      size,
      {
        query: normalizedQuery,
        fields: [
          'preferredTitles',
          'expressions.manifestations.titles.mainTitles.value',
          'expressions.manifestations.titles.mainTitles.subTitles.value',
        ],
      },
      signal,
    ).then(mapWorkHits),
  );
};
